var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Pane',{staticClass:"mt-l has-text-centered",attrs:{"title":"Success!"}},[_c('p',[_vm._v("Your payment is complete and your subscription has been extended.")]),_c('p',{staticClass:"mt-l"},[_vm._v("Thanks for supporting rekordcloud!")])])}
var staticRenderFns = []

export { render, staticRenderFns }